// assets
import {
  IconSettings,
  IconMapPin,
  IconFileUpload,
  IconCategory2,
  IconCategoryMinus,
  IconWorld,
  IconContract,
  IconReceiptTax,
  IconMenu2,
  IconCreditCardPay,
  IconBuildingBank,
  IconUserSearch,
  IconDeviceDesktopAnalytics,
  IconCashOff,
  IconBox,
  IconEyeSearch,
  IconBook2,
  IconCash,
  IconCreditCard,
  IconMessage2,
  IconMail,
  IconChecklist,
  IconStackFront,
  IconList
} from '@tabler/icons-react';

// types
import { NavItemType } from 'types';

const icons = {
  IconSettings: IconSettings,
  IconMapPin: IconMapPin,
  IconFileUpload: IconFileUpload,
  IconLoanCategory: IconCategory2,
  IconLoanSubcategory: IconCategoryMinus,
  IconLanguage: IconWorld,
  IconAgreementGrievance: IconContract,
  IconTaxConfiguration: IconReceiptTax,
  IconMenuMaster: IconMenu2,
  IconPayoutSetting: IconCreditCardPay,
  IconLoans: IconBuildingBank,
  IconLoanApplicant: IconUserSearch,
  IconLoanMonitoring: IconDeviceDesktopAnalytics,
  IconDisbursement: IconCashOff,
  IconAppVersionControl: IconBox,
  IconManualKycReview: IconEyeSearch,
  IconLedgerMaster: IconBook2,
  IconLoan: IconCash,
  IconAccount: IconBuildingBank,
  IconPaymentMethods: IconCreditCard,
  IconSmsMaster: IconMessage2,
  IconMailTemplate: IconMail,
  IconMailTemplateList: IconList,
  IconBRERules: IconChecklist,
  IconBRERuleList: IconList,
  IconBRETemplateList: IconStackFront
};

// ==============================|| MENU ITEMS - SETTINGS ||============================== //

const settings: NavItemType = {
  id: 'settings',
  title: 'Settings',
  icon: icons.IconSettings,
  type: 'group',
  children: [
    {
      id: 'serviceable-area-pincode',
      title: 'Serviceable Pincode',
      type: 'collapse',
      icon: icons.IconMapPin,
      children: [
        {
          id: 'serviceable-area-pincode',
          title: 'Pincode Management',
          type: 'item',
          url: '/settings/serviceable-area-pincode',
          breadcrumbs: false
        },
        {
          id: 'upload-history',
          title: 'Upload History',
          type: 'item',
          url: '/settings/upload-history',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'loan-category',
      title: 'Loan Category',
      type: 'item',
      icon: icons.IconLoanCategory,
      url: '/settings/loan-category',
      breadcrumbs: false
    },
    {
      id: 'loan-subcategory',
      title: 'Loan Subcategory',
      type: 'item',
      icon: icons.IconLoanSubcategory,
      url: '/settings/loan-subcategory',
      breadcrumbs: false
    },
    {
      id: 'language-master',
      title: 'Language Master',
      type: 'item',
      url: '/settings/language-master',
      icon: icons.IconLanguage,
      breadcrumbs: false
    },
    {
      id: 'account-classification',
      title: 'Account Classification',
      type: 'item',
      url: '/settings/account-classification',
      icon: icons.IconAgreementGrievance,
      breadcrumbs: false
    },
    {
      id: 'bucket-master',
      title: 'Bucket Master',
      type: 'item',
      url: '/settings/bucket-master',
      icon: icons.IconFileUpload,
      breadcrumbs: false
    },
    {
      id: 'agreement-grievance',
      title: 'Agreement & Grievance',
      type: 'item',
      url: '/settings/agreement-grievance',
      icon: icons.IconAgreementGrievance,
      breadcrumbs: false
    },
    {
      id: 'tax-configuration',
      title: 'Tax Configuration',
      type: 'item',
      url: '/settings/tax-configuration',
      icon: icons.IconTaxConfiguration,
      breadcrumbs: false
    },
    {
      id: 'user-management',
      title: 'User Management',
      type: 'collapse',
      icon: icons.IconSettings,
      children: [
        {
          id: 'menu-master',
          title: 'Menu Master',
          type: 'item',
          url: '/settings/menu-master',
          breadcrumbs: false
        },
        {
          id: 'designation-master',
          title: 'Designation Master',
          type: 'item',
          url: '/settings/designation-master',
          breadcrumbs: false
        },
        {
          id: 'users',
          title: 'Users',
          type: 'item',
          url: '/settings/users',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'payout-setting',
      title: 'Payout Setting',
      type: 'item',
      url: '/settings/payout-setting',
      icon: icons.IconPayoutSetting,
      breadcrumbs: false
    },
    {
      id: 'app-version-control',
      title: 'App Version Control',
      type: 'item',
      url: '/settings/app-version-control',
      icon: icons.IconAppVersionControl,
      breadcrumbs: false
    },
    {
      id: 'payment-settings',
      title: 'Payment Settings',
      type: 'collapse',
      icon: icons.IconPaymentMethods,
      children: [
        {
          id: 'payment-methods',
          title: 'Payment Methods',
          type: 'item',
          url: '/settings/payment-methods',
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'sms-master',
      title: 'SMS Master',
      type: 'item',
      url: '/settings/sms-master',
      icon: icons.IconSmsMaster,
      breadcrumbs: false
    }
  ]
};

export default settings;